import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=4b06e60e"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"
import style0 from "./Service.vue?vue&type=style&index=0&id=4b06e60e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./services.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fbackend.limatours.com.pe%2Fresources%2Fjs%2Fpages%2FClients%2FManageClient%2FService%2FService.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports